import Cookies from "universal-cookie";
import moment from 'moment';

const cookies = new Cookies();

export const setCookies = (name, value, expiryAfterDays = 86400) => {
  let expire = new Date();
  expire.setDate(expire.getDate() + expiryAfterDays);
  cookies.set(name, value, { expires: expire, path: "/" });
};

export const getCookies = (name) => {
  return cookies.get(name);
};

export const removeCookies = (name, options = { path: "/" }) => {
  cookies.remove(name, options);
};

export function capitalizeFirstLetter(str) {
  if (str) {
    return str.substring(0, 1).toUpperCase() + str.substring(1);
  } else {
    return str;
  }
}


export const formateDate = date => {
  return moment(date).format('YYYY[-]MM[-]DD');
};

export const formateDatemdy = date => {
  return moment(date).format('MM[/]DD[/]YYYY');
};

export const formateDateandtime = date => {
  return moment(date).format('MM[/]DD[/]YYYY HH:mm');
};

export const formatDateDMY = (date) => {
  return moment(date).format("DD MMM YYYY"); 
};

export const formatDateTime = (date) => {
  return moment(date).format("ddd, DD MMM YYYY [at] hh:mm A");
};

export const formatTime = (timeString) => {
  return moment(timeString, "HH:mm:ss").format("hh:mm A");
};

export const capitalizeFirstLetterOfEveryWord = (str) => {
  if (!str) return "N/A"; // Return "N/A" if the string is empty or null
  return str
    .split(" ") // Split the string by spaces to get individual words
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
    .join(" "); // Join the words back together with spaces
};


export const stripHtmlAndTruncate = (html, maxLength = 20) => {
  if (!html) return '';
  
  // Remove HTML tags
  const plainText = html.replace(/<[^>]*>/g, '');
  
  // Trim whitespace
  const trimmed = plainText.trim();
  
  // Truncate if needed
  if (trimmed.length > maxLength) {
    return trimmed.slice(0, maxLength) + '...';
  }
  
  return trimmed;
};


